import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import Uno from './Uno';
import Dos from './Dos';
import Tres from './Tres';
import Cuatro from './Cuatro';
import Cinco from './Cinco';
import Seis from './Seis';
import Siete from './Siete';
import Ocho from './Ocho';
import Nueve from './Nueve';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const PDescriptionLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const [backVII, setBackVII] = useState('transparent');
  const [backVIII, setBackVIII] = useState('transparent');
  const [backIX, setBackIX] = useState('transparent');

  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#1') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#2') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#3') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#4') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorA']);
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#5') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorA']);
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#6') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI(appColors['ColorA']);
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#7') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII(appColors['ColorA']);
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key == '#8') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII(appColors['ColorA']);
      setBackIX('transparent');
    } else if (key == '#9') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#1' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Health Priority</Text></Content>}/>
          <Link href='#2' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Why is worryng?</Text></Content>}/>
          <Link href='#3' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Accelerated Aging</Text></Content>}/>
          <Link href='#4' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Tracking Aging</Text></Content>}/>
          <Link href='#5' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>iMoAge</Text></Content>}/>
          <Link href='#6' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Biomarkers</Text></Content>}/>
          <Link href='#7' title={<Content className='ContentAnchor' style={{borderColor: backVII}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Antibodies</Text></Content>}/>
          <Link href='#8' title={<Content className='ContentAnchor' style={{borderColor: backVIII}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Integrating</Text></Content>}/>
          <Link href='#9' title={<Content className='ContentAnchor' style={{borderColor: backIX}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>References</Text></Content>}/>
        </Anchor>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='1'>
              <Uno/>
            </div>
            <div id='2'>
              <Dos/>
            </div>
            <div id='3'>
              <Tres/>
            </div>
            <div id='4'>
              <Cuatro/>
            </div>
            <div id='5'>
              <Cinco/>
            </div>
            <div id='6'>
              <Seis/>
            </div>
            <div id='7'>
              <Siete/>
            </div>
            <div id='8'>
              <Ocho/>
            </div>
            <div id='9'>
              <Nueve/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default PDescriptionLogic;
